var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3863 23.3846V12.1111L0.674316 7.01426V18.4606L11.3863 23.3846Z",
    fill: "#B7844D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1206 10.1674L22.8326 5.3297L12.1206 0.189697L1.27901 5.3297L12.1206 10.1674Z",
    fill: "#B7844D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9845 12.1111V23.3846L23.5669 18.4606V7.23022L12.9845 12.1111Z",
    fill: "#B7844D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3863 23.3846V12.1111L0.674316 7.01426V18.4606L11.3863 23.3846Z",
    stroke: "#B7844D",
    strokeWidth: 0.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1206 10.1674L22.8326 5.3297L12.1206 0.189697L1.27901 5.3297L12.1206 10.1674Z",
    stroke: "#B7844D",
    strokeWidth: 0.3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9845 12.1111V23.3846L23.5669 18.4606V7.23022L12.9845 12.1111Z",
    stroke: "#B7844D",
    strokeWidth: 0.3
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCube);
export default __webpack_public_path__ + "static/media/Cube.47ebd4b08a4a51cebbf35c4d6bba143b.svg";
export { ForwardRef as ReactComponent };